import React from 'react';

import VmManager from '../components/vm/manager';

export default class VmPage extends React.Component{
	render(){
		return (
			<div style={{ margin: 16 }}>
				<VmManager/>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/containers/vm-page.js